// extracted by mini-css-extract-plugin
module.exports = {"logo":"Menu_logo__1Vbli","menuItem":"Menu_menuItem__2YWWO"};